import * as React from 'react'
import { cn } from '@repo/ui/lib/utils'
import { cva, VariantProps } from 'class-variance-authority'

const textareaVariants = cva(
  cn(
    'flex min-h-0 w-full min-w-0 rounded-md px-3 py-2 text-base outline-none selection:bg-primary selection:text-primary-foreground placeholder:text-muted-foreground disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
    'aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40',
    'transition-[color,background-color,border-color,box-shadow,opacity] duration-150',
  ),
  {
    defaultVariants: {
      variant: 'default',
    },
    variants: {
      variant: {
        default: cn(
          'border border-input bg-transparent shadow-xs dark:bg-input/30',
          'focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50',
        ),
        ghost: cn(
          'bg-transparent shadow-none',
          'hover:bg-accent dark:hover:bg-accent/50',
          'focus-visible:bg-accent dark:focus-visible:bg-accent/50',
        ),
      },
    },
  },
)

function Textarea({
  className,
  variant,
  ...props
}: React.ComponentProps<'textarea'> & VariantProps<typeof textareaVariants>) {
  return (
    <textarea
      className={cn(textareaVariants({ className, variant }))}
      data-slot="textarea"
      {...props}
    data-sentry-component="Textarea" data-sentry-source-file="textarea.tsx" />
  )
}

export { Textarea }
